import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";

import { useBookingData } from "modules/nextcall/store";
import SoftBadge from "modules/common/SoftBadge";

export const UserStatus = ({ engagements }) => {
  const { orderData } = useBookingData();
  const [status, setStatus] = useState("");
  const [color, setColor] = useState("");

  const { latest_order_count, latest_order_date } = engagements;

  const _status = useCallback(() => {
    if (!orderData || orderData.length < 1) {
      setStatus("New");
      setColor("success");
      return;
    }

    if (Array.isArray(orderData)) {
      const _engagementDue = orderData.map((val) => {
        if (val.due_date && moment().isAfter(val.due_date)) {
          return 1;
        } else {
          return 0;
        }
      });

      if (latest_order_count >= 1) {
        if (_engagementDue.every((val) => val === 0)) {
          setStatus("New");
          setColor("success");
          return;
        } else if (!_engagementDue.every((val) => val === 1)) {
          setStatus("Active");
          setColor("info");
          return;
        } else if (moment().diff(moment(latest_order_date), "days") > 15) {
          setStatus("Inactive");
          setColor("danger");
          return;
        }
      }
    }
  }, [orderData, latest_order_count, latest_order_date]);

  useEffect(() => {
    _status();
    return () => {
      setStatus("");
    };
  }, [_status]);

  if (status) {
    return <SoftBadge bg={color}>{status.toUpperCase()}</SoftBadge>;
  } else {
    return null;
  }
};
